import React from "react";

function LoadingSkeleton() {
  return (
    <div>
      <div className="border border-gray-300 shadow rounded-md p-4 max-w-lg w-full mx-auto">
        <div className="animate-pulse flex space-x-4">
          <div className="flex-1 space-y-6 py-1">
            <div className="space-y-2">
              <div className="h-2 w-28 bg-slate-200 rounded"></div>
              <div className="h-2 w-36 bg-slate-200 rounded"></div>
            </div>
            <div>
              <div className="h-18 w-28 bg-slate-200  col-span-2"></div>
            </div>
            <div className="space-y-3">
              <div className="flex space-x-2">
                <div className="space-y-2 w-80">
                  <div className="h-2 bg-slate-200 rounded col-span-2"></div>
                  <div className="h-2 bg-slate-200 rounded col-span-1"></div>
                  <div className="h-2 bg-slate-200 rounded"></div>
                </div>
                <div className="h-18 w-28 bg-slate-200  col-span-2"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoadingSkeleton;
